import { useSilentAwaken } from '~/utils/active/use-silent-awaken';
import { $CurrentArticle } from '@article/shared/atoms/current-article';
import { useAtomValue } from 'jotai';
import { ArticleDetailUtil, EArticleClass } from 'shared/models';
import { useMemo } from 'react';
import { DeepLinkBuildingProps } from '~/utils/active/schema';
import { $CurrentArticleRelatedPost } from '@article/shared/atoms/current-article-related-post';

export const PostSilentAwaken = () => {
  const currentArticle = useAtomValue($CurrentArticle);
  const relatedPosts = useAtomValue($CurrentArticleRelatedPost);
  const hasFulfilled = useMemo(() => Boolean(relatedPosts.items), [relatedPosts.hasMore]);

  const schemaOption: DeepLinkBuildingProps = useMemo(() => {
    if (!ArticleDetailUtil.isArticleAvailable(currentArticle)) {
      return { pageType: 'feed', categoryId: 0 };
    }

    const { articleClass, groupId } = currentArticle;

    return { pageType: articleClass === EArticleClass.VIDEO ? 'video' : 'article', groupId };
  }, []);

  useSilentAwaken({
    schemaOption,
    hasFulfilled,
  });

  return <></>;
};
